import type { AfterShipTag } from 'api/aftership/types';
import { UPCOMING_ORDER_STATUS, type UpcomingOrderStatus } from 'shared/constants/orders';

// Map AfterShip statuses to our categories
export const PREPARING_STATUSES: AfterShipTag[] = ['Pending', 'InfoReceived'];
export const SHIPPED_STATUSES: AfterShipTag[] = [
  'InTransit',
  'OutForDelivery',
  'AttemptFail',
  'Exception'
];
export const DELIVERED_STATUSES: AfterShipTag[] = ['Delivered', 'AvailableForPickup'];

// Type guard functions
export const isPreparingStatus = (tag: AfterShipTag): tag is (typeof PREPARING_STATUSES)[number] =>
  PREPARING_STATUSES.includes(tag as (typeof PREPARING_STATUSES)[number]);

export const isShippedStatus = (tag: AfterShipTag): tag is (typeof SHIPPED_STATUSES)[number] =>
  SHIPPED_STATUSES.includes(tag as (typeof SHIPPED_STATUSES)[number]);

export const isDeliveredStatus = (tag: AfterShipTag): tag is (typeof DELIVERED_STATUSES)[number] =>
  DELIVERED_STATUSES.includes(tag as (typeof DELIVERED_STATUSES)[number]);

export const getUpcomingOrderStatus = (afterShipTag: AfterShipTag): UpcomingOrderStatus => {
  if (isPreparingStatus(afterShipTag)) {
    return UPCOMING_ORDER_STATUS.PREPARING;
  }

  if (isShippedStatus(afterShipTag)) {
    return UPCOMING_ORDER_STATUS.SHIPPED;
  }

  if (isDeliveredStatus(afterShipTag)) {
    return UPCOMING_ORDER_STATUS.DELIVERED;
  }

  // Default fallback for any unrecognized status
  return UPCOMING_ORDER_STATUS.PREPARING;
};
